// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__eDg0r","title":"styles_title__Db0Tz","address":"styles_address__57JM6","phoneWrapper":"styles_phoneWrapper__CoPRa","website":"styles_website__VsQDG","logo":"styles_logo__zIJvC"};
module.exports.__checksum = "c10b58185e7b"